import Phaser from 'phaser';
import MainScene from 'src/app/Scenes/MainScene';
import { name_to_attributes } from './dataClasses/Mappings';
import { GameObjectAttributes } from './CustomAttributes';
import BaseLevelScene from 'src/app/Scenes/BaseLevelScene';

interface RotationSpriteAttributes {
  scene: MainScene | BaseLevelScene;
  x: number;
  y: number;
  texture: string;
  frame: string;
}

export class RotationSprite extends Phaser.Physics.Matter.Sprite {
  scene: MainScene | BaseLevelScene;
  drops: string[] = [];
  droppedItems: any[] = [];
  attributes: GameObjectAttributes;
  constructor(data: RotationSpriteAttributes) {
    let { scene, x, y, texture, frame } = data;
    super(scene.matter.world, x, y, texture, frame);
    this.scene = scene;
    if (name_to_attributes.has(frame)) {
      this.attributes = name_to_attributes.get(frame);
      this.name = frame;
    } else if (name_to_attributes.has(texture)) {
      this.attributes = name_to_attributes.get(texture);
      this.name = texture;
    }
    this.drops = this.attributes.drops;
    this.x += this.width / 2;
    this.y -= this.height / 2;
    this.setDepth(1);
    this.angle = scene.player.angle;
    this.scene.add.existing(this);
  }
}
